import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, TextField, Button, Typography, Paper } from "@mui/material";
import { setToken } from "../auth";

export default function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogin = async () => {
        setError("");
        setLoading(true);

        try {
            const res = await fetch("/api/login", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ username, password }),
            });

            const data = await res.json().catch(() => ({}));

            if (!res.ok) {
                setError(data.error || "Identifiant ou mot de passe incorrect");
                return;
            }

            setToken(data.token);
            const redirectTo = location.state?.from || "/";
            navigate(redirectTo, { replace: true });
        } catch (err) {
            setError("Erreur réseau : " + err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
            <Paper sx={{ p: 4, width: "400px" }}>
                <Typography variant="h5" align="center" gutterBottom>
                    Connexion équipe
                </Typography>

                <TextField
                    fullWidth
                    label="Identifiant"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handleLogin()}
                    sx={{ mb: 2 }}
                />

                <TextField
                    fullWidth
                    type="password"
                    label="Mot de passe"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handleLogin()}
                    sx={{ mb: 2 }}
                />

                {error && (
                    <Typography color="error" sx={{ mb: 2 }}>
                        {error}
                    </Typography>
                )}

                <Button fullWidth variant="contained" onClick={handleLogin} disabled={loading}>
                    {loading ? "Connexion…" : "Se connecter"}
                </Button>
            </Paper>
        </Box>
    );
}